import React from 'react';
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';

const Cadm = () => {
    const pscState = useSelector(state => state.pscState.value)
    const config = pscState.config || {}

    const sharepointBlock = config.feature_sharepoint_enabled === "1" 
                          ? (
                              <span>
                                  <h3><span className="header--integrations">Integrations</span></h3>
                                  <ul className="list-group clear-list m-t">
                                      <li className="list-group-item">
                                          <Link to="/cadm/sharepoint_application" className="link--sharepoint_application">Sharepoint</Link>
                                          <span className="help-block m-b-none">
                                              Sharepoint Application configuration
                                          </span>
                                      </li>
                                  </ul>
                              </span>
                          )
                          : (null)
    
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Configuration and Document Management</h2>
                            <div className="ibox-content">
                                <div className="row">

                                    <div className="col-lg-3">

                                        <h3><span className="header--configuration-schemes">Configuration Schemes</span></h3>
                                        <ul className="list-group clear-list m-t">
                                            <li className="list-group-item">
                                                <Link to="/cadm/reference_structures" className="link--reference-structures">Reference Structures</Link>
                                                <span className="help-block m-b-none">
                                                    Build reference structures
                                                </span>
                                            </li>
                                            <li className="list-group-item">
                                                <Link to="/cadm/typecode_groups" className="link--typecode-groups">Type-Code Lists</Link>
                                                <span className="help-block m-b-none">
                                                    Manage sets of type-codes
                                                </span>
                                            </li>
                                            <li className="list-group-item">
                                                <Link to="/cadm/typecode_group_mappings" className="link--typecode-group-mappings">Type-Code Maps</Link>
                                                <span className="help-block m-b-none">
                                                    Relate each type-code list to a set of document types
                                                </span>
                                            </li>
                                            <li className="list-group-item">
                                                <Link to="/cadm/project_configuration_schemes" className="link--configuration-schemes">Configuration Schemes</Link>
                                                <span className="help-block m-b-none">
                                                    Select a reference structure and type-code map for each configured item type
                                                </span>
                                            </li>
                                        </ul>

                                    </div>
                                    <div className="col-lg-3">

                                        <h3><span className="header--document-types">Document Types</span></h3>
                                        <ul className="list-group clear-list m-t">

                                            <li className="list-group-item">
                                                <Link to="/cadm/std_documents" className="link--std-documents">Portfolio Document Types</Link>
                                                <span className="help-block m-b-none">
                                                    Manage portfolio document type names 
                                                </span>
                                            </li>

                                            <li className="list-group-item">
                                                <Link to="/cadm/qms_document_types" className="link--qms-document-types">QMS Document Types</Link>
                                                <span className="help-block m-b-none">
                                                    Manage QMS Document types
                                                </span>
                                            </li>
                                            <li className="list-group-item">
                                                <Link to="/cadm/qa_document_types" className="link--qa-document-types">QA Document Types</Link>
                                                <span className="help-block m-b-none">
                                                    Manage QA Document types
                                                </span>
                                            </li>
                                            <li className="list-group-item">
                                                <Link to="/cadm/qa_record_types" className="link--qa-record-types">QA Record Types</Link>
                                                <span className="help-block m-b-none">
                                                    Manage QA Record types
                                                </span>
                                            </li>
                                        </ul>

                                    </div>
                                    <div className="col-lg-3">

                                        <h3><span className="header--templates">Templates</span></h3>
                                        <ul className="list-group clear-list m-t">

                                            <li className="list-group-item">
                                                <Link to="/cadm/templates" className="link--templates">Templates</Link>
                                                <span className="help-block m-b-none">
                                                    Manage all of your templates and SMART templates
                                                </span>
                                            </li>
                                            <li className="list-group-item">
                                                <Link to="/cadm/template_placeholders" className="link--template-placeholders">SMART Template Placeholders</Link>
                                                <span className="help-block m-b-none">
                                                    See which field placeholders you can add to your SMART templates
                                                </span>
                                            </li>
                                        </ul>

                                        <h3><span className="header--reports">Reports</span></h3>
                                        <ul className="list-group clear-list m-t">
                                            <li className="list-group-item">
                                                <Link to="/cadm/report_types" className="link--report-types">Report Types</Link>
                                                <span className="help-block m-b-none">
                                                    Create section headings (table of contents) for each report type
                                                </span>
                                            </li>
                                            <li className="list-group-item">
                                                <Link to="/cadm/report_schemes" className="link--report-schemes">Report Schemes</Link>
                                                <span className="help-block m-b-none">
                                                    Define which document types will appear under each section heading
                                                </span>
                                            </li>
                                        </ul>

                                    </div>
                                    <div className="col-lg-3">

                                        <h3><span className="header--general">General</span></h3>
                                        <ul className="list-group clear-list m-t">
                                            <li className="list-group-item">
                                                <Link to="/cadm/models" className="link--models">Models</Link>
                                                <span className="help-block m-b-none">
                                                    Manage the set of model names available to projects
                                                </span>
                                            </li>
                                            <li className="list-group-item">
                                                <Link to="/cadm/classifications" className="link--classifications">Classification Levels</Link>
                                                <span className="help-block m-b-none">
                                                    Manage information classification levels and distribution statements
                                                </span>
                                            </li>
                                        </ul>

                                        {sharepointBlock}
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cadm
